<div class="container mx-auto px-4 py-4">
  @if (loading()) {
    <app-sector-list-skeleton></app-sector-list-skeleton>
  } @else if (error()) {
    <div class="bg-red-50 dark:bg-red-900 border border-red-200 dark:border-red-700 rounded-lg p-6">
      <div class="text-red-800 dark:text-red-200">
        <h3 class="text-lg font-medium mb-2">Error Loading Sector</h3>
        <p>{{ error() }}</p>
      </div>
    </div>
  } @else {
    <!-- Back Button -->
    <div class="flex items-center justify-start mb-4">
      <app-go-back-button (goBack)="goBack()"></app-go-back-button>
    </div>

    <div class="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-6">
      <div class="mb-6">
        <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
           {{ sectorName() }} Sector Companies ({{ candidates().length }})
        </h2>
        <p class="text-sm text-gray-600 dark:text-gray-300 mt-1">
          Investment candidates in this sector
        </p>
      </div>

      <!-- Filters Section -->
      <div class="mb-6">
        <div class="flex flex-col md:flex-row gap-4">
          <!-- Market Cap Filter -->
          <div class="flex-1">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Market Cap
            </label>
            <p-select
              [options]="marketCapOptions"
              [(ngModel)]="selectedMarketCap"
              (onChange)="onMarketCapChange()"
              optionLabel="label"
              optionValue="value"
              placeholder="Select market cap"
              size="large"
              [checkmark]="true"
              class="w-full">
            </p-select>
          </div>

          <!-- Discount Filter -->
          <div class="flex-1">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Discount
            </label>
            <p-select
              [options]="discountOptions"
              [(ngModel)]="selectedDiscount"
              (onChange)="onDiscountChange()"
              optionLabel="label"
              optionValue="value"
              placeholder="Select discount"
              size="large"
              [checkmark]="true"
              class="w-full">
            </p-select>
          </div>

          <!-- Clear Filters Button (only show when filters are active) -->
          @if (hasActiveFilters()) {
            <div class="flex items-end md:w-auto w-full">
              <button
                (click)="clearFilters()"
                class="w-full md:w-auto px-6 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition-colors whitespace-nowrap">
                Clear Filters
              </button>
            </div>
          }
        </div>
      </div>

      @if (candidates().length === 0 && allCandidates().length > 0) {
        <!-- Empty state due to filters -->
        <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-12 text-center">
          <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-2">No Matches Found</h3>
          <p class="text-gray-600 dark:text-gray-300 mb-4">
            No companies match your current filter criteria.
          </p>
          <button
            (click)="clearFilters()"
            class="px-6 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-lg transition-colors">
            Clear Filters
          </button>
        </div>
      } @else if (candidates().length === 0) {
        <!-- Empty state - no data at all -->
        <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-12 text-center">
          <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-2">No Candidates Found</h3>
          <p class="text-gray-600 dark:text-gray-300">There are currently no candidates in the {{ sectorName() }} sector.</p>
        </div>
      } @else {
        <!-- Stock table with data -->
        <app-stock-table
          [stocks]="candidates()"
          [isLoading]="loading()"
          [sortField]="sortField()"
          [sortOrder]="sortOrder()"
          (stockSelected)="onStockClick($event)"
          (sortChanged)="onSortChanged($event)">
        </app-stock-table>
      }
    </div>
  }
</div>
